import React, { memo } from 'react';

export default memo(function EditIcon(props:any) {
	return (		
        <svg width={props.width ? props.width : "48px"} height={props.height ? props.height : "48px"} viewBox="0 0 48 48" fill="none">
            <path d="M19.5 34.5C19.2 34.5 18.9 34.4 18.7 34.2L11.2 27.5C10.7 27 10.6 26.2 11.1 25.7C11.6 25.2 12.4 25.1 12.9 25.6L19.5 31.5L36.9 14.2C37.4 13.7 38.2 13.7 38.7 14.2C39.2 14.7 39.2 15.5 38.7 16L20.4 34.2C20.1 34.4 19.8 34.5 19.5 34.5Z" 
            fill={props.color || '#888'}></path>
        </svg>
	);
});
